import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SonarlyGuard"] */ "/vercel/path0/apps/web/src/components/sonarly-guard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/Nunito-Variable.ttf\",\"variable\":\"--font-nunito\",\"weight\":\"300 700\",\"style\":\"normal\",\"display\":\"swap\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/globals.css");
